import { createSelector, OutputSelector } from 'reselect'
import { ICarrierMatchesState, IMatch } from 'apps/booking/types/carrierMatches'
import { IStore } from 'apps/booking/utils/reducers'

const selectCarrierMatches = (state: IStore): ICarrierMatchesState => state.carrierMatches

interface MatchesRequestState
  extends OutputSelector<
    IStore,
    {
      loading: boolean
      error: string
    },
    (
      res: ICarrierMatchesState
    ) => {
      loading: boolean
      error: string
    }
  > {}
interface MatchTotalCount
  extends OutputSelector<
    IStore,
    { totalCount: number },
    (res: ICarrierMatchesState) => { totalCount: number }
  > {}
interface MatchList
  extends OutputSelector<
    IStore,
    {
      result?: (IMatch | undefined)[]
    },
    (
      res: ICarrierMatchesState
    ) => {
      result?: (IMatch | undefined)[]
    }
  > {}

export const matchesRequestStateSelector: MatchesRequestState = createSelector(
  selectCarrierMatches,
  ({ error, loading }) => ({ loading, error })
)

export const matchTotalCountSelector: MatchTotalCount = createSelector(
  selectCarrierMatches,
  ({ totalCount }) => ({ totalCount })
)

export const matchListSelector: MatchList = createSelector(selectCarrierMatches, ({ data }) => ({
  result: data.result?.map(id => data?.entities?.matches && data?.entities?.matches[id]),
}))
